import { LoaderCircle } from "lucide-react";
import React from "react";
import "./LoaderAnimated.scss";

interface Props {
  size?: number;
}
const LoaderAnimated = (props: Props) => {
  const { size = 16 } = props;
  return <LoaderCircle size={size} className="loader-animated" />;
};

export default LoaderAnimated;
